import React from 'react';

interface IPageMetaDataProps {
  title?: string;
  description?: string;
}

const PageMetaData: React.FC<React.PropsWithChildren<IPageMetaDataProps>> = ({ title, description }) => {
  React.useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let metaDescription = document.head.children.namedItem('description');
      metaDescription?.setAttribute('content', description);
    }
  }, [title, description]);

  return null;
};
export default PageMetaData;
